/**
 * @file Redux mappers for composeMetaStatus container
 */

import { MapDispatchToProps, MapStateToProps } from 'react-redux';

import AppState from '../../../models/state';
import { changeStatusRequest } from '../../../store/actions/draftsMain';

import { DispatchProps, OwnProps, StateProps } from './types';

/**
 * Map Redux action dispatch to component props
 *
 * @param dispatch          Redux action dispatcher
 * @param ownProps          Passed props
 * @param ownProps.nodeType The id of the draft
 * @returns                 Mapped state
 */
export const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { nodeType },
) => ({
  /**
   * Dispatches request to set status draft
   *
   * @param status Task status
   */
  requestStatusChange: status => {
    dispatch(changeStatusRequest(nodeType, status));
  },
});

/**
 * Map Redux app state to component props
 *
 * @param appState          Current app state
 * @param appState.drafts   Drafts in state
 * @param ownProps          Passed props
 * @param ownProps.nodeType The id of the draft
 * @returns                 Mapped state
 */
export const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = ({ drafts }, { nodeType }) => ({
  dataStatusCurrent: drafts.get(nodeType)?.status ?? null,
});
